import { render, staticRenderFns } from "./Subsidiaries.vue?vue&type=template&id=341780c8&"
import script from "./Subsidiaries.vue?vue&type=script&lang=ts&"
export * from "./Subsidiaries.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports